import ApiHandler from 'requests/apiHandler'
import NotImplementedError from 'requests/errors/notImplementedError'
import { ParamElement } from 'requests/objects/param'

/**
 * SearchFiltersHandler
 * @augments {ApiHandler<ParamElement>}
 */
export default class SearchFiltersHandler extends ApiHandler {
    constructor() {
        super({ type: ParamElement, errorType: Object, key: 'search-filters' })
    }

    /**
     * Search filter clients
     * @param {string} text text used to filter clients
     * @returns {import('requests/apiHandler').RequestApi<ParamElement[]>} Request
     */
    searchAddresses(text) {
        const request = this.initFetchRequest({ url: ['addresses'], method: 'GET', params: { text } })

        return this.getRequestApi(
            () => request.fetchRequest
                // eslint-disable-next-line new-cap
                .then(res => /** @type {any} */(res.data[this.objectName])?.map(x => new (this.type)(x)) ?? [])
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }

    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @override
     * @returns {any} any
     */
    // eslint-disable-next-line class-methods-use-this
    getAll() {
        throw new NotImplementedError()
    }

    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @override
     * @returns {any} any
     */
    // eslint-disable-next-line class-methods-use-this
    getById() {
        throw new NotImplementedError()
    }

    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @override
     * @returns {any} any
     */
    // eslint-disable-next-line class-methods-use-this
    create() {
        throw new NotImplementedError()
    }

    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @override
     * @returns {any} any
     */
    // eslint-disable-next-line class-methods-use-this
    updateById() {
        throw new NotImplementedError()
    }

    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * @override
     * @returns {any} any
     */
    // eslint-disable-next-line class-methods-use-this
    removeById() {
        throw new NotImplementedError()
    }
}
